export default [
  {
    path: '/comboPurchaseH5Page',
    name: 'ComboPurchaseH5Page',
    component: () => import('@/views/combo/ComboPurchaseH5Page.vue'),
    meta: {
      requiresAuth: false,
      name: '扫码支付',
    },
  },
  {
    path: '/paperDetectPurchaseH5Page',
    name: 'PaperDetectPurchaseH5Page',
    component: () => import('@/views/combo/PaperDetectPurchaseH5Page.vue'),
    meta: {
      requiresAuth: false,
      name: '扫码支付',
    },
  },
]
